// extracted by mini-css-extract-plugin
export var header_content = "ChooseRoleItem-module--header_content--sbnop";
export var long_arrow_right = "ChooseRoleItem-module--long_arrow_right--r0Pr6";
export var modal_body = "ChooseRoleItem-module--modal_body--Swptf";
export var modal_register_role__item = "ChooseRoleItem-module--modal_register_role__item--V1pkE";
export var modal_register_role__list = "ChooseRoleItem-module--modal_register_role__list--t-1Tv";
export var register_button = "ChooseRoleItem-module--register_button--hpov3";
export var register_modal_text = "ChooseRoleItem-module--register_modal_text--7k85Y";
export var register_text_description = "ChooseRoleItem-module--register_text_description--qxW8g";
export var register_text_header = "ChooseRoleItem-module--register_text_header--Eaf++";
export var small_modall_header = "ChooseRoleItem-module--small_modall_header--If6Z3";